import React from 'react';
import PropTypes from 'prop-types';

export default class Badge extends React.Component {

    render() {
        const {color} = this.props;

        if ( !color ) return null;

        return (
            <span
                className="badge-state"
                style={{backgroundColor: color}}
            />
        );
    }

}

Badge.propTypes = {
    color: PropTypes.string.isRequired,
};

Badge.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/shared/components/Badge.js